// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__ounhu","content":"LayoutSettings_content__ihimm"};